module.exports = __webpack_public_path__ + "img/5.faccf699.png";